document.addEventListener('DOMContentLoaded', function () {
    const breadcrumbsNav = document.querySelector('.breadcrumbs__nav');

    if (breadcrumbsNav) {
        breadcrumbsNav.addEventListener('wheel', function (event) {
            if (event.deltaY !== 0) {
                event.preventDefault();
                breadcrumbsNav.scrollLeft += event.deltaY; // Przewijanie poziome
            }
        });
    }
});